import React, { useState, useEffect } from 'react';
import { Tree, Select, Empty, Spin } from 'antd';
import { CaretDownOutlined, FileTextOutlined, FolderOpenOutlined, FolderOutlined,} from '@ant-design/icons';
import Iconfont from "../../../../components/Iconfont/Iconfont";
import Api from "../../../../api";
import storage from "../../../../utils/storage";
import "./index.scss";

let defalutPolicyThemeList = [];
const PolicyTree = ({policyTreeChange}) => {
    const [searchNav, setSearchNav] = useState([
        {value:"1", label:"全量政策"},
        {value:"2", label:"部门关注"}
    ]);
    const [active, setActive] = useState('1');
    const userInfo = storage.getItem("userInfo") || {};

    const [publicPolicyTree, setPublicPolicyTree] = useState([]);
    const [defaultExpandedKeys, setDefaultExpandedKeys] = useState([]);
    const [defaultExpandedKeysSelected, setDefaultExpandedKeysSelected] = useState([]);
    const [activeAll, setActiveAll] = useState(true);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [departmentId, setDepartmentId] = useState('');
    const [selectedPolicies, setSelectedPolicies] = useState([]); // 精选政策树
    const [themePolicy, setThemePolicy] = useState([]); // 主题政策树

    const [selectedSpinning, setSelectedSpinning] = useState(false);
    const [treeSpinning, setTreeSpinning] = useState(false);

    useEffect(() => { 
        getPublicPolicyTree();
    }, [])


    const switchMav = (index) => {
        setActive(index);
        setPublicPolicyTree([]);
        setSelectedPolicies([]);
        if (index === '1') {
            getPublicPolicyTree();
            // 全量政策
        } else {
            // 部门关注
            getDepartmentList()
        }
    }

    const getDepartmentList = async() => { 
        const res = await Api.Department.getDepartmentListAll({data:{
            knowledgeRel: 0,
            knowledgeTypeIds: ['4']
        }});
        if(res&&res.code === 0){

            let departmentId = "";
            // 默认选中自己的部门
            if(userInfo.departmentId){
                departmentId = userInfo.departmentId;
            }else{
                departmentId = res.data[0].id;
            }

            setDepartmentId(departmentId);
            getPolicySortData(departmentId);
            getPublicPolicyTree(departmentId);
            setDepartmentList(res.data);
           
        }
    }

    // 全量政策
    const getPublicPolicyTree = async(departmentId) => {
        setSelectedSpinning(true);
        let res = await Api.Knowledge.getPublicPolicyeTree({
            data: {
                departmentId: departmentId  ? departmentId : -1
            }
        });
        setSelectedSpinning(false);
        if(res && res.code === 0 && res.data){
            setPublicPolicyTree(res.data);

            let keys = [];
            res.data.map(item=>{
                keys.push(item.id)
            })
            setDefaultExpandedKeys(keys)
        }
    }

    const onSelect = (selectedKeys, e, type) => {
        const node = e.node;
        setActiveAll(false);
        setSelectedKeys(selectedKeys)
        console.log(node,selectedKeys)
        if(type === "selectedPolicies"){
            // 精选政策
            let dataObj = {};
            // 主题
            selectedKeys.map((item)=>{
                let newItem = item.split("-");
                let key = newItem[0];
                dataObj[key] = dataObj[key] ? dataObj[key] : {};
            })
            // 字典
            selectedKeys.map((item)=>{
                let newItem = item.split("-")
                let key = newItem[0], dict = newItem[1];
                if(dict){
                    dataObj[key][dict] = [];
                }
            })
            // 年份
            selectedKeys.map((item)=>{
                let newItem = item.split("-")
                let key = newItem[0], dict = newItem[1], time = newItem[2];
                if(time){
                    dataObj[key][dict].push(time);
                }
            })

            let newData  = [];
            for(let key in dataObj){
                let newObj = {
                    policyLableThemeId: key,
                    policyTimeDictParams: []
                }

                for(let keys in dataObj[key]){
                    newObj.policyTimeDictParams.push({
                        dictCode:keys,
                        times:dataObj[key][keys]
                    })
                }
                newData.push(newObj)
            }

            console.log(newData,"newData");

            policyTreeChange({
                'policyThemeId':"",
                'policyLableThemeId':"",
                'lableThemeParams':newData,
                'departmentId': departmentId
            })
        }else if(type === "themePolicy"){ 
            // 主题政策
            policyTreeChange({
                'policyThemeId':node.id,
                'policyLableThemeId':node.policyLableThemeId,
                'lableThemeParams':[],
                'departmentId': departmentId
            })
        }else if(type === "allPolicy"){ 
            // 全量政策
            policyTreeChange({
                'policyThemeId':node.id,
                'policyLableThemeId':node.policyLableThemeId,
                'lableThemeParams':[],
                'departmentId': "",
            })
        }
    }

     const titleRender = (nodeData) => {
        const domId = `nodeId-${nodeData.id}`;
        return (
            <span id={domId} style={{whiteSpace: "pre-wrap", wordBreak: "break-all",}}>{nodeData.policyName}</span>
        );
    }

    const handleChange = (value) => {
        setDepartmentId(value);
        getPolicySortData(value);
        getPublicPolicyTree(value);
        console.log(`selected ${value}`);
    };

    // 精选政策
    const getPolicySortData = async (departmentId) => { 
        setTreeSpinning(true);
        const res = await Api.Policy.getPolicyLableThemeByLoginUser({data:{ 
            searchMyself: false,
            departmentId
        }});
        setTreeSpinning(false);
        if (res && res.code === 0 && res.data) {
            let keys = [];
            let newData = res.data.map(item=>{
                keys.push(item.id)
                let childrenList = [];
                if(item.sysDictDatas){
                    item.sysDictDatas.map(it=>{
                        childrenList.push(
                            {
                                dictLabel: it.dictLabel,
                                dictCode: `${item.id}-${it.dictCode}`,
                                isLeaf: false,
                            }
                        )
                    })
                }
                return {
                    dictLabel: item.themeName,
                    dictCode: item.id,
                    isLeaf: childrenList?.length > 0 ? false: true,
                    children: childrenList
                }
            })

            console.log(newData,keys,"newData")
            setSelectedPolicies(newData);

            setDefaultExpandedKeysSelected(keys);
                
        }else{
            setSelectedPolicies([]);
        }
    };

    const onLoadData = ({ key, children }) =>
        new Promise(async(resolve) => {
        if (children) {
            resolve();
            return;
        }
        let newData = await getPolicyYearByDictCodeF(key);
        
        setSelectedPolicies((origin) =>
            updateTreeData(origin, key, newData),
        );

        resolve();
    });
    
    const getPolicyYearByDictCodeF = (key) => {

        return new Promise(async (resolve, reject) => {
            let policyLableThemeId = key.split('-')[0];
            let dictCode = key.split('-')[1];
            
            let res = await Api.Dict.getPolicyYearByDictCode({
                data:{
                    policyLableThemeId,
                    dictCode,
                }
            })
    
            const {data, code} = res;
            if(code === 0 && data){
                let newData = data.map(item=>{
                    return {
                        dictLabel: item,
                        dictCode: `${key}-${item}`,
                        isLeaf:true
                    }
                })
                resolve(newData);
            }else{
                resolve([]);
            }
        });
    }

    const updateTreeData = (list, key, children) =>
        list.map((node) => {
          if (node.dictCode === key) {
            return {
              ...node,
              children,
            };
          }
          if (node.children) {
            return {
              ...node,
              children: updateTreeData(node.children, key, children),
            };
          }
          return node;
    });

    return(
        <div className="policyTreeFrameV7">

            <div className="searchNav">
                {searchNav.map((item, index) => (
                    <div className={`searchNavItem ${active === item.value ? 'active' : ''}`} key={item.value} onClick={()=>switchMav(item.value)}>{item.label}</div>
                ))}
            </div>

            {/* 全量政策 */}
            <div className={`allClassification ${activeAll ? 'active':''} ${active === '1' ? '' : 'hide'}`}  onClick={()=>{
                setActiveAll(!activeAll);
                setSelectedKeys([]);
                policyTreeChange({
                    'policyThemeId': "",
                    'policyLableThemeId': "",
                })
            }}><Iconfont type={'icon-fenlei'}/>全部</div>

            <div className={`allClassificationBox ${active === '1' ? '' : 'hide'}`}>
                <Spin spinning={selectedSpinning}>
                {(publicPolicyTree && publicPolicyTree.length > 0) ?
                    (<Tree
                        showIcon={true}
                        icon={(item) => {
                            const isTheme = String(item.policyThemeType) === "1";
                            return isTheme ? <FileTextOutlined /> : (item.expanded ? <FolderOpenOutlined /> : <FolderOutlined />);
                        }}
                        switcherIcon={<CaretDownOutlined />}
                        treeData={publicPolicyTree}
                        onSelect={(selectedKeys, e)=>onSelect(selectedKeys, e, 'allPolicy')}
                        titleRender={titleRender}
                        selectedKeys={selectedKeys}
                        defaultExpandedKeys={defaultExpandedKeys}
                        blockNode
                        fieldNames={{
                            title:"policyName",
                            key: "id",
                            children:"children",
                            isLeaf:"policyThemeType",
                        }}
                    />):
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                }</Spin>
            </div>
            
            {/* 部门关注 */}
            <div className={`departmentTree ${active === '2' ? '' : 'hide'}`}>
                <Select
                    style={{width: '100%',}}
                    onChange={handleChange}
                    options={departmentList}
                    value={departmentId}
                    fieldNames={{
                        label:"name",
                        value: "id",
                    }}
                />
                <div className="title">精选政策</div>
                <Spin spinning={selectedSpinning}>
                    {(selectedPolicies && selectedPolicies.length > 0) ?<Tree
                        showIcon={true}
                        icon={(item) => {
                            const isTheme = String(item.policyThemeType) === "1";
                            return isTheme ? <FileTextOutlined /> : (item.expanded ? <FolderOpenOutlined /> : <FolderOutlined />);
                        }}
                        switcherIcon={<CaretDownOutlined />}
                        treeData={selectedPolicies}
                        onSelect={(selectedKeys, e)=>onSelect(selectedKeys, e, 'selectedPolicies')}
                        selectedKeys={selectedKeys}
                        defaultExpandedKeys={defaultExpandedKeysSelected}
                        loadData={onLoadData}
                        blockNode
                        fieldNames={{ title: 'dictLabel', key: 'dictCode'}}
                    />:
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                }</Spin>

                <div className="title">主题政策</div>
                <Spin spinning={treeSpinning}>
                    {(publicPolicyTree && publicPolicyTree.length > 0) ?
                    (<Tree
                        showIcon={true}
                        icon={(item) => {
                            const isTheme = String(item.policyThemeType) === "1";
                            return isTheme ? <FileTextOutlined /> : (item.expanded ? <FolderOpenOutlined /> : <FolderOutlined />);
                        }}
                        switcherIcon={<CaretDownOutlined />}
                        treeData={publicPolicyTree}
                        onSelect={(selectedKeys, e)=>onSelect(selectedKeys, e, 'themePolicy')}
                        selectedKeys={selectedKeys}
                        defaultExpandedKeys={defaultExpandedKeys}
                        blockNode
                        fieldNames={{
                            title:"policyName",
                            key: "id",
                            children:"children",
                            isLeaf:"policyThemeType",
                        }}
                    />):
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                }
                </Spin>
            </div>

        </div>
    )
}

export default PolicyTree;
